import { api } from 'common/frontend/api';
import { getOrderNumberFromOrderBarcode } from 'common/modules/orderReceipts/utils';
import { OrderInfo } from 'common/types';
import { chain } from 'lodash';

export const getCompletedBookingsBySearchTerm = (args: {
	shopId: string;
	locationId: string | null;
	searchTerm: string;
}): Promise<OrderInfo[]> => {
	return Promise.all([
		searchCompletedBookingsByShopperName(args),
		searchCompletedBookingsByProductCodes(args),
		searchCompletedBookingsByOrderNumber(args),
	]).then((results) => {
		return chain(results)
			.flatten()
			.uniqBy((order) => order.id)
			.value();
	});
};

export const searchCompletedBookingsByShopperName = async (args: {
	shopId: string;
	locationId: string | null;
	searchTerm: string;
}): Promise<OrderInfo[]> => {
	if (!args.searchTerm) return [];
	let query = api()
		.orders.get.where('shopId', '==', args.shopId)
		.whereArray('shopperNameKeywords', 'array-contains', args.searchTerm.trim().toLowerCase())
		.where('rentalState', '==', 'COMPLETED');

	if (!!args.locationId) {
		query = query.where('endLocation.id', '==', args.locationId);
	}

	return query.orderBy('endDateReturned', 'desc').get();
};

export const searchCompletedBookingsByProductCodes = async (args: {
	shopId: string;
	locationId: string | null;
	searchTerm: string;
}): Promise<OrderInfo[]> => {
	if (!args.searchTerm) return [];
	let query = api()
		.orders.get.where('shopId', '==', args.shopId)
		.whereArray('rentalProductCodes', 'array-contains', args.searchTerm.trim().toUpperCase())
		.where('rentalState', '==', 'COMPLETED');

	if (!!args.locationId) {
		query = query.where('endLocation.id', '==', args.locationId);
	}

	return query.orderBy('endDateReturned', 'desc').get();
};

export const searchCompletedBookingsByOrderNumber = async (args: {
	shopId: string;
	locationId: string | null;
	searchTerm: string;
}): Promise<OrderInfo[]> => {
	if (!args.searchTerm) return [];
	const orderNumber = getOrderNumberFromOrderBarcode(args.searchTerm);
	if (!orderNumber) return [];
	let query = api()
		.orders.get.where('shopId', '==', args.shopId)
		.where('orderNumber', '==', orderNumber)
		.where('rentalState', '==', 'COMPLETED');

	if (!!args.locationId) {
		query = query.where('endLocation.id', '==', args.locationId);
	}

	return query.orderBy('endDateReturned', 'desc').get();
};
